module.exports = __webpack_public_path__ + "static/media/flash.cb28b42f.svg";